import { render, staticRenderFns } from "./CardTeamMembers.vue?vue&type=template&id=7cb0ad60&scoped=true&"
import script from "./CardTeamMembers.vue?vue&type=script&lang=js&"
export * from "./CardTeamMembers.vue?vue&type=script&lang=js&"
import style0 from "./CardTeamMembers.vue?vue&type=style&index=0&id=7cb0ad60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb0ad60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCard,VCardTitle,VChip,VIcon,VImg,VSimpleTable,VSpacer})
